<template>
    <transition name="modal">
        <div class="modal-mask">
            <div class="modal-wrapper" @click="$emit('close')">
                <div class="modal-container" @click.stop>
                    <div class="modal-header">
                        {{ $t('_nouvelle_alarme_') }}
                        <slot name="cross">
                            <v-icon style="float: right; top: 0.3vh;" @click="$emit('close')">mdi-close</v-icon>
                            <v-icon v-if="choixMpp" style="float: right; margin-right: 1vw; top: 0.3vh;"
                                @click="backFromChoiceMpp()">mdi-arrow-left</v-icon>
                        </slot>
                    </div>

                    <div class="modal-body">
                        <div v-if="!choixMpp" style="margin-bottom: 7vh;">
                            Sélectionner les blocs concernés
                            <div class="map">
                                <l-map ref="refMap" class="small-map-sep" :zoom="zoom" :center="center"
                                    @update:zoom="zoomUpdated" @update:center="centerUpdated"
                                    @update:bounds="boundsUpdated">
                                    <custom-tile-layer :url="tileProviders.url" :attribution="tileProviders.attribution"
                                        :maxZoom="22" :maxNativeZoom="18" />
                                    <l-feature-group ref="featureGroup" />
                                </l-map>
                            </div>
                            <div v-if="blocsMpps.length>1">
                            <div class="nom"> Point de mesure concerné dans le bloc (optionnel) </div>
                            
                            <select class="createSelect" v-model="datapoint">
                                <option v-for="(data, index) in blocsMpps" :key="'zone' + index">{{ data }}
                                </option>
                            </select>
                            </div>
                            <v-btn style="font-size: 0.5rem; float: right;" @click="toChoiceMpp">
                                Les blocs concernés n'existent pas
                            </v-btn>
                        </div>
                        <div v-else>
                            <div class="nom"> Zone concernée </div>
                            <select class="createSelect" v-model="datapoint">
                                <option v-for="(data, index) in sortedDatapoints" :key="'zone' + index">{{ data }}
                                </option>
                            </select>
                        </div>

                        <div class="nom"> {{ $t('_type_d_alarme_') }}</div>
                        <select class="createSelect" v-model="typeAlarme">
                            <option v-for="(type, index) in typeListe" :key="'type' + index"> {{ type }} </option>
                        </select>

                    </div>

                    <div class="modal-footer">
                        <v-btn :disabled="!complet"
                            style="float: right; background-color: #F49301; padding: 1vh; font-size: 1rem"
                            @click="createAlarm">
                            {{ $t('_creer_alarme_') }}
                        </v-btn>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import api from '@/api/api';
import backend from '@/api/backend';
import L from 'leaflet';
import { LMap, LFeatureGroup } from 'vue2-leaflet';

import 'leaflet-toolbar/dist/leaflet.toolbar.css'
import 'leaflet-toolbar';

import 'leaflet-distortableimage'
import 'leaflet-distortableimage/dist/leaflet.distortableimage.css'

const CustomTileLayer = {
    name: 'CustomTileLayer',
    props: ['url', 'attribution', 'maxZoom', 'maxNativeZoom'],
    mounted() {
        const tileLayer = L.tileLayer(this.url, {
            attribution: this.attribution,
            maxZoom: this.maxZoom,
            maxNativeZoom: this.maxNativeZoom,
            noWrap: true,
            tms: false,
        });

        tileLayer.addTo(this.$parent.mapObject);


    },
    render() {
        return null;
    }
};

export default {

    components: { LMap, CustomTileLayer, LFeatureGroup },

    props: {
        geoLoc: {
            required: false,
        }
    },

    async mounted() {

        try {
            var res = (await api.get_layout_model_global_info(this.installation_id))
            this.center = [res.data.latitude, res.data.longitude]
            this.site = res.data.name

            this.mpps = (await api.get_all_full_layout(this.installation_id)).data
            this.mpps.forEach((json) => {
                json["id"] = json.mpp
            })


            this.datapoints = []
            this.datapoints[0] = this.$t("_site_complet_")
            for (const idMpp in this.mpps) {
                this.datapoints.push("mpp " + this.mpps[idMpp].mpp)
                const nom = "inv-" + this.mpps[idMpp].mpp.split("-")[0]
                if (this.datapoints.indexOf(nom) === -1) {
                    this.datapoints.push(nom)
                }
            }
        } catch {
            const res = (await backend.get_install_form(this.installation_id)).data
            const description = res.description
            this.site = description.nom
            this.center = [parseFloat(description.markerLatLng0), parseFloat(description.markerLatLng1)]
            const calepinage = res.layouts
            this.historique = res.history
            this.mpps = []
            this.datapoints = []
            this.datapoints[0] = this.$t("_site_complet_")
            for (const idLigne in calepinage) {
                const json = {}
                json["init_module_nb"] = calepinage[idLigne].initNbModule
                json["init_string_nb"] = calepinage[idLigne].initNbChaine
                for (let idOnduleur in this.historique) {
                    if (this.historique[idOnduleur].nom === calepinage[idLigne].nomOnduleur)
                        json["inv_model"] = this.historique[idOnduleur].type
                }
                json["module_nb"] = calepinage[idLigne].nbModule
                json["mpp"] = calepinage[idLigne].nom
                json["plane_id"] = calepinage[idLigne].nomRampant
                json["pv_model"] = calepinage[idLigne].typeModule
                json["string_nb"] = calepinage[idLigne].nbChaine
                json["id"] = calepinage[idLigne].cleMpp

                this.mpps.push(json)
                this.datapoints.push("mpp " + json.mpp)
            }
            for (const idOnd in this.historique) {
                this.datapoints.push(this.historique[idOnd].nom)
            }
        }
        await this.fetchContours();
        await this.fetchRectanglesMpp();
        this.$refs.refMap.mapObject.locate({ setView: false, maxZoom: 30 });
        this.$refs.refMap.mapObject.on('locationfound', this.onLocationFound);
        this.$refs.refMap.mapObject.on('locationerror', this.onLocationError);
        try {
            this.corners = (await backend.get_mask_install(this.installation_id)).data
            this.fileURL = URL.createObjectURL((await backend.get_mask_file_install(this.installation_id)).data)
            const map = this.$refs.refMap.mapObject

            const options = {
                corners: this.corners,
                suppressToolbar: true,
                editable: false,
                actions: [],
                mode: ''
            }
            this.overlay = L.distortableImageOverlay(this.fileURL, options).addTo(map)
            this.imageExiste = true
        }
        catch (error) {
            console.error("Pas d'image à recuperer", error)
        }
    },

    beforeDestroy() {
        URL.revokeObjectURL(this.fileURL);
    },

    data() {
        return {
            historique: [],
            corners: [],
            fileURL: "",
            blocId: [],
            blocsMpps: [],
            typeAlarme: "",
            typeListe: ["Telecom link failure", "Curtailment", "VoC", "Fan Failure", "Shading", "Soiling", "IV_curve", "Cleaning"],
            datapoint: "",
            mpps: [],
            datapoints: [],
            installation_id: this.$route.params.id,
            complet: false,
            choixMpp: false,

            tileProviders:
            {
                url: "https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}.png",
                visible: true,
                name: "satelliteESRI",
                attribution: 'Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community',
            },
            zoom: 17,
            center: [48.866667, 2.333333],
            rectangles: [],
            polygonCoords: [],
            mpp_assigned: [],
        }
    },
    computed: {
        // Propriété calculée qui retourne les données triées
        sortedDatapoints() {
            console.log("datapoints: ", this.datapoints)
            const [first, ...rest] = this.datapoints;

            const mItems = [];
            const iItems = [];

            for (const item of rest) {
                const firstLetter = item[0]?.toLowerCase();
                if (firstLetter === 'm') {
                    mItems.push(item);
                } else {
                    iItems.push(item);
                }
            }

            mItems.sort((a, b) => a.localeCompare(b, undefined, { sensitivity: 'base' }));
            iItems.sort((a, b) => a.localeCompare(b, undefined, { sensitivity: 'base' }));
            // `others` can be ignored or appended at the end if needed

            return [first, ...iItems, ...mItems]; // + others if needed

        }
    },
    methods: {
        async fetchContours() {
            try {
                const response = await backend.get_edges_install(this.installation_id);
                this.polygonCoords = response.data;

                await this.$nextTick();

            } catch (err) {
                // this.$emit("detour");
            }
        },

        async fetchRectanglesMpp() {
            try {
                const [response1, response2] = await Promise.all([backend.get_blocs_install(this.installation_id), backend.get_m_pts_install(this.installation_id)]);
                this.rectangles = response1.data;
                this.mpp_assigned = response2.data;

                await this.$nextTick();

            } catch (err) {
                this.rectangles = [];
                this.mpp_assigned = [];
            }
            this.initPolygons();
        },

        initPolygons() {
            const poly = L.polygon(this.polygonCoords);
            this.$refs.refMap.mapObject.fitBounds(poly.getBounds());
            this.center = [poly.getBounds().getCenter().lat, poly.getBounds().getCenter().lng]
            this.rectangles.forEach((rectangle, index) => {
                this.addPolygonToLayer(rectangle, this.mpp_assigned[index], index);
            });
        },

        zoomUpdated(zoom) {
            this.zoom = zoom;
        },

        centerUpdated(center) {
            this.center = center;
        },

        boundsUpdated(bounds) {
            this.bounds = bounds;
        },

        map_ready() {
            this.$r
            const poly = L.polygon(this.rectangleCoords);
            this.$refs.refMap.mapObject.fitBounds(poly.getBounds());
            // this.$refs.mapRef.mapObject.openPopup()
        },

        addPolygonToLayer(rectangle, mpp, index) {
            const polygon = L.polygon(rectangle);
            polygon.options.mpp = mpp;
            polygon.id = index;
            polygon.on('click', () => {
                if (this.blocId.includes(index)) {
                    this.blocId.splice(this.blocId.indexOf(index), 1)
                }
                else {
                    this.blocId.push(index)
                }
                this.$refs.featureGroup.mapObject.eachLayer(polygone => {
                    polygone.setStyle(this.getStylePolygon(polygone))
                })
            });
            polygon.bindTooltip(this.getTooltipText(polygon), {
                permanent: false,    // Le tooltip apparaîtra au survol
                direction: 'top',    // Position du tooltip par rapport au polygone
                offset: [0, -10]     // Décalage du tooltip
            });
            polygon.setStyle(this.getStylePolygon(polygon));
            this.$refs.featureGroup.mapObject.addLayer(polygon);
            this.nextId += 1;
        },

        getStylePolygon(layer) {
            let color = (layer.options.mpp.length === 0) ? 'red' : 'blue';
            let fcolor = (this.blocId.includes(layer.id)) ? 'blue' : 'grey';
            let fopa = 0.6;
            return {
                color: color,
                fillColor: fcolor,
                fillOpacity: fopa,
            }
        },

        getTooltipText(layer) {
            var tooltipText = null;
            if (layer.options.mpp.length < 1) {
                tooltipText = this.$t('_pas_de_point_associe_')
            }
            else {
                tooltipText = this.$t('_point_associe_') + ' : ' + layer.options.mpp
            }
            return tooltipText;
        },

        async createAlarm() {
            const utilisateur = (await api.currentUser()).data.id
            let coordonnees = [this.center.lat, this.center.lng]
            if (this.geoLoc !== null) {
                coordonnees = this.geoLoc
            }
            if (this.choixMpp) {
                this.blocId = []
                let parse = false
                this.mpps.forEach((mpp) => {
                    if (this.datapoint === "mpp " + mpp.mpp) {
                        parse = true
                        this.datapoint = "mpp-" + mpp.id
                    }
                })
                if (!parse)
                    this.historique.forEach((inv) => {
                        if (this.datapoint === inv.nom) {
                            parse = true
                            this.datapoint = "inv-" + inv.id
                        }
                    })
            }

            else
                if (/^[a-zA-Z]/.test(this.datapoint))
                    this.datapoint = ""
            await backend.post_new_alarmquery(this.typeAlarme, this.blocId, this.datapoint, "" + coordonnees + "", this.installation_id, utilisateur)
            this.$emit("close")
        },

        checkComplete() {
            this.complet = false
            if (this.choixMpp && this.typeAlarme !== "" && this.datapoint !== "") {
                this.complet = true
            }
            if (!this.choixMpp && this.typeAlarme !== "" && this.blocId.length !== 0)
                this.complet = true
        },

        toChoiceMpp() {
            this.choixMpp = true
            // this.blocId = []
        },

        async backFromChoiceMpp() {
            this.choixMpp = false
            await this.$nextTick();

            if (this.imageExiste) {
                const map = this.$refs.refMap.mapObject

                const options = {
                    corners: this.corners,
                    suppressToolbar: true,
                    editable: false,
                    actions: [],
                    mode: ''
                }

                this.overlay = L.distortableImageOverlay(this.fileURL, options).addTo(map)
            }
            this.initPolygons()
            this.$refs.refMap.mapObject.locate({ setView: false, maxZoom: 30 });
            this.$refs.refMap.mapObject.on('locationfound', this.onLocationFound);
            this.$refs.refMap.mapObject.on('locationerror', this.onLocationError);
            // this.blocId = []
        },
        getBlocsMpps() {
            let blocsMpps = []
            this.$refs.featureGroup.mapObject.eachLayer(bloc => {
                if (this.blocId.includes(bloc.id)) {
                    bloc.options.mpp.forEach(mpp =>{
                        if (! blocsMpps.includes(mpp)){
                            blocsMpps=blocsMpps.concat(mpp)
                        }
                    })
                }
            })
            this.blocsMpps = blocsMpps
        }
    },

    watch: {
        typeAlarme: {
            handler() {
                this.checkComplete()
            },
            deep: true,
        },
        blocId: {
            handler() {
                this.checkComplete()
                this.getBlocsMpps()
            }
        },
        datapoint: {
            handler() {
                this.checkComplete()
            },
            deep: true
        },
        choixMpp: {
            handler() {
                this.checkComplete()
            }
        }
    }

}


</script>

<style scoped>
.modal-container {
    width: 80vw;
    height: 80vh;
    margin: 0px auto;
    padding: 2vh;
    background-color: rgba(255, 255, 255, 1);
    border-radius: 2px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
    transition: all 0.3s ease;
    border-radius: 0.25rem;
    position: relative;
    flex-direction: column;
}

.modal-header {
    font-weight: bold;
    font-size: 1.5rem;
    color: #212121;
    height: fit-content;
}

.modal-body {
    overflow-y: auto;
    overflow-x: hidden;
    margin-top: 2vh;
    max-height: 68vh;
    padding-bottom: 4rem;
}

.modal-footer {
    padding: 16px 16px;
    background-color: white;
    color: white;
    position: absolute;
    width: 100%;
    bottom: 0;
    right: 0;
}

.map {
    height: 48vh;
    width: 70vw;
    margin-bottom: 2vh;
}

.small-map-sep {
    aspect-ratio: 1 / 2;
    z-index: 0;
}
</style>